module.exports = __webpack_public_path__ + "public/img/w0.65365e52.png";